import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import CircularProgressbar from 'src/components/CircularProgressbar';
import ConditionGradient from 'src/components/ConditionGradient';
import { DentalIQBeta } from 'src/components/DentalIQBeta/DentalIQBeta';
import { DataTestIds } from 'src/config/dataTestIds';
import usePatientScoring from 'src/hooks/api/usePatientScoring';
import Section from '../Section';
import { SeeAll } from '../SeeAll/SeeAll';
import * as S from './DentalIQ.styles';
const DentalIQ = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation();
  const {
    data
  } = usePatientScoring();
  const dentalIQ = data?.[0];
  const dentalIQRedirect = '/dental-iq';
  const score = dentalIQ ? Math.round(dentalIQ.overallScore.score) : 0;
  const conditionsScore = dentalIQ ? dentalIQ.conditions.teeth.score : 0;
  const gumsScore = dentalIQ ? dentalIQ.conditions.gums.score : 0;
  useEffect(() => {
    router.prefetch(dentalIQRedirect);
  }, [router.prefetch]);
  return /*#__PURE__*/React.createElement(Section, {
    show: !!dentalIQ,
    title: /*#__PURE__*/React.createElement(S.Frame, null, t('b2c.home.subheading.dentalIQ'), /*#__PURE__*/React.createElement(DentalIQBeta, {
      tooltipPlacement: "top"
    })),
    extra: /*#__PURE__*/React.createElement(SeeAll, {
      "data-testid": DataTestIds.DentalIQLearnMore,
      text: t('b2c.home.learnMore'),
      onClick: () => {
        router.push(dentalIQRedirect);
      }
    })
  }, /*#__PURE__*/React.createElement(Box, {
    onClick: () => router.push(dentalIQRedirect)
  }, /*#__PURE__*/React.createElement(S.Card, {
    "data-testid": DataTestIds.DentalIQDashboardWidget
  }, /*#__PURE__*/React.createElement(CircularProgressbar, {
    value: score,
    label: t('b2c.dentalIQ.score'),
    compact: true
  }), /*#__PURE__*/React.createElement(S.Conditions, null, /*#__PURE__*/React.createElement(S.Item, {
    flex: 1
  }, /*#__PURE__*/React.createElement(ConditionGradient, {
    value: conditionsScore,
    compact: true,
    label: t('b2c.dentalIQ.labels.teethCondition')
  })), /*#__PURE__*/React.createElement(S.Item, {
    flex: 0
  }, /*#__PURE__*/React.createElement(S.Divider, null)), /*#__PURE__*/React.createElement(S.Item, {
    flex: 1
  }, /*#__PURE__*/React.createElement(ConditionGradient, {
    value: gumsScore,
    compact: true,
    label: t('b2c.dentalIQ.labels.gumCondition')
  }))))));
};
export default DentalIQ;